import React, { useEffect, useMemo, useState } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import AvatarEditor from "react-avatar-editor";
import Button from "components/Elements/Button/Button.js";
// imported as an JImage cos we need to use class Image as well here
import JImage from "components/Elements/Image/Image.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { UploaderScroller } from "./UploaderScroller";

import "./UserBrandingCoverUploader.scss";

const _URL = URL || window.URL || window.webkitURL;

const UserBrandingCoverSelector = React.forwardRef(
  (
    {
      backgroundImage,
      image,
      size,
      handleClick,
      imageSizes,
      setImageSizes,
      error,
    },
    ref
  ) => {
    const { getHtmlByKey, getTextByKey } = useContent();

    //scroller scaling logic
    const [scale, setScale] = useState(1);
    const handleScale = (e) => {
      const scale = parseFloat(e.target.value);
      setScale(scale);
    };

    useEffect(() => {
      if (image) {
        const img = new Image();
        img.onload = function () {
          setImageSizes(() => ({
            valid: this.width > 1479 && this.height > 755,
            width: this.width,
          }));
        };
        if (typeof image !== "string") {
          const url = _URL.createObjectURL(image);
          img.src = url;
        } else {
          img.src = image;
        }
      }
    }, [image]);

    return (
      <div className={`user-background-cover-selector`}>
        <div className="background-picture">
          <div className={`background-selector-top`}>
            <JImage
              name="personal/header-background"
              ext="jpg"
              title=""
              alt=""
            />
          </div>
          <div
            className={`background-selector-center ${
              image ? "background-image-selected" : ""
            }`}
            style={
              !image
                ? {
                    backgroundImage: `url(${backgroundImage})`,
                    height: `${size.width / 1.96 - 20}px`,
                  }
                : {}
            }
          >
            {(image && !imageSizes.valid) || error ? (
              <div className="validation-size-container">
                <div className="validation-content">
                  {getHtmlByKey(
                    error ? error : "embed-background-validation-size-text"
                  )}
                </div>
              </div>
            ) : null}
            {image ? (
              <>
                <AvatarEditor
                  ref={ref}
                  image={image}
                  width={Math.round(size.width - 20)}
                  height={Math.round(size.width / 1.96 - 20)}
                  crossOrigin=""
                  border={0}
                  color={[255, 255, 255, 0.6]} // RGBA
                  scale={parseFloat(scale)}
                  rotate={0}
                />
                <div className="upload-image-button">
                  <Button onClick={handleClick}>
                    {getTextByKey("profile-upload-image-button")}
                    <Icon name="upload" white />
                  </Button>
                </div>
              </>
            ) : (
              <div className="click-to-action-circle" onClick={handleClick}>
                <Icon name="cloud-upload" white></Icon>
                <span>{getTextByKey("profile-upload-image-button")}</span>
              </div>
            )}
          </div>
          <div className={`background-selector-bottom`}>
            <JImage name="personal/footer-image" ext="jpg" title="" alt="" />
          </div>
        </div>
        {image && imageSizes.width > 1600 && image.indexOf("https://") < 0 ? (
          <UploaderScroller
            image={image}
            handleScale={handleScale}
            maxValue={imageSizes.width / 1600}
          />
        ) : null}
      </div>
    );
  }
);

export default UserBrandingCoverSelector;
